module.exports = __webpack_public_path__ + "img/message-quote.47c9fcb8.svg";